export enum Endpoints {
  LOGIN = '/auth/login',
  STORE_LIST = '/store/list',
  STORE_SETTINGS = '/store/settings/get',
  STORE_UPDATE_SETTINGS = '/store/settings/set',
  // Staff
  STAFF_LIST = '/staff/entity/portal/list',
  STAFF_UPSERT = 'staff/entity/upsert',
  STAFF_ARCHIVE = 'staff/entity/archive',
  STAFF_BULK_UPDATE = 'staff/entity/bulk/update',
  STAFF_PASSCODE = '/staff/entity/validate/passcode',
  STAFF_SHIFT_LIST = 'staff/shift/portal/list',
  STAFF_TIMESHEET_LIST = 'staff/timesheet/list',
  STAFF_TIMESHEET_UPSERT = 'staff/timesheet/upsert',
  STAFF_TIMESHEET_PUBLISH = 'staff/timesheet/publish',
  STAFF_TIMESHEET_UNPUBLISH = 'staff/timesheet/unpublish',
  STAFF_SHIFT_UPSERT = 'staff/shift/upsert',
  STAFF_SHIFT_ARCHIVE = 'staff/shift/archive',
  STAFF_JOB_TITLE_LIST = 'staff/job-title/portal/list',
  STAFF_JOB_TITLE_UPSERT = 'staff/job-title/upsert',
  STAFF_JOB_TITLE_ARCHIVE = 'staff/job-title/archive',
  STAFF_EXPERIENCE_LEVEL_LIST = 'staff/experience-level/portal/list',
  STAFF_EXPERIENCE_LEVEL_UPSERT = 'staff/experience-level/upsert',
  STAFF_EXPERIENCE_LEVEL_ARCHIVE = 'staff/experience-level/archive',
  STAFF_WORK_SECTION_LIST = 'staff/work-section/portal/list',
  STAFF_WORK_SECTION_UPSERT = 'staff/work-section/upsert',
  STAFF_WORK_SECTION_ARCHIVE = 'staff/work-section/archive',
  STAFF_ATTENDANCE_UPDATE_TIMES = 'staff/attendance/update-times',
  ROLE_LIST = '/staff/roles/portal/list',
  ROLE_UPSERT = 'staff/roles/upsert',
  ROLE_ARCHIVE = 'staff/roles/archive',
  ROLE_CONFIG = 'staff/roles/config',
  // Customers
  CUSTOMER_LIST = 'customer/portal/list',
  CUSTOMER_UPSERT = 'customer/upsert',
  CUSTOMER_ARCHIVE = 'customer/archive',
  CUSTOMER_BULK_UPDATE = 'customer/bulk/update',
  CATEGORIES_LIST = '/pos/category/portal/list',
  ITEMS_LIST = '/pos/item/portal/list',
  ORDERS_LIST = '/sale/portal/list',
  ORDERS_VIEW = 'sale/portal/view',
  ORDERS_UPDATE_STATUS = 'sale/update-status',
  APPPAIR_PAIRED_PARTNERS = 'apppair/paired-partners',
  APPPAIR_RESEND_POS = 'apppair/resend-pos',
  APPPAIR_VERIFACTU_MONITORING_SUMMARY = 'apppair/verifactu/monitoring/summary',
  APPPAIR_VERIFACTU_MONITORING_SUBMISSIONS = 'apppair/verifactu/monitoring/submissions',
  APPPAIR_VERIFACTU_SUBMISSION_SEND = 'apppair/verifactu/submission/send',
  APPPAIR_AUTO_ACCEPT = 'apppair/auto-accept',
  APPPAIR_ADYEN_UI_COMPONENTS = 'apppair/adyen/ui-components',
  APPPAIR_ADYEN_PAYOUTS_GET = 'apppair/adyen/payouts/get',
  APPPAIR_ADYEN_TRANSACTIONS_GET = 'apppair/adyen/transactions/get',
  APPPAIR_ADYEN_INVOICES_GET = 'apppair/adyen/invoices/get',
  APPPAIR_ADYEN_INVOICE_DOWNLOAD_URL_GET = 'apppair/adyen/invoices/download-url/get',
  // Lightspeed
  LIGHTSPEED_PAIR_BUSINESS = 'apppair/lightspeed/pair/business',
  LIGHTSPEED_CATALOGUE = 'apppair/lightspeed/get-catalogue',
  LIGHTSPEED_LOCATION_LIST = 'apppair/lightspeed/location/portal/list',
  LIGHTSPEED_PAIR_STORE = 'apppair/lightspeed/pair/store',
  LIGHTSPEED_DISCONNECT = 'apppair/lightspeed/disconnect',
  LIGHTSPEED_STORE_DISCONNECT = 'apppair/lightspeed/disconnect/store',
  LIGHTSPEED_PARTNER_STORES = 'apppair/lightspeed/pair/store/data',
  LIGHTSPEED_POS_PROFILES = 'apppair/lightspeed/pos-profile/list',
  // Slack
  APPPAIR_SLACK_PAIR_SYSTEM = 'apppair/slack/pair/business',
  APPPAIR_SLACK_GET_CHANNEL = 'apppair/slack/get-channels',
  APPPAIR_SLACK_LOCATION_LIST = 'apppair/slack/location/portal/list',
  APPPAIR_SLACK_DISCONNECT_STORE = 'apppair/slack/disconnect/store',
  APPPAIR_SLACK_DISCONNECT_Business = 'apppair/slack/disconnect/business',
  APPPAIR_SLACK_PAIR_STORE = 'apppair/slack/pair/store',
  // Glovo
  APPPAIR_GLOVO_STORE_DISCONNECT = 'apppair/glovo/disconnect/store',
  APPPAIR_GLOVO_PAIR_BUSINESS = 'apppair/glovo/pair/business',
  APPPAIR_GLOVO_LOCATION_LIST = 'apppair/glovo/location/portal/list',
  APPPAIR_GLOVO_PAIR_STORE = 'apppair/glovo/pair/store',
  APPPAIR_GLOVO_DISCONNECT = 'apppair/glovo/disconnect',
  // Wolt
  APPPAIR_WOLT_DISCONNECT = 'apppair/wolt/disconnect/store',
  // Bolt
  APPPAIR_BOLT_DISCONNECT = 'apppair/bolt/disconnect/store',
  // Deliveroo
  APPPAIR_DELIVEROO_PAIR_BUSINESS = 'apppair/deliveroo/pair/business',
  APPPAIR_DELIVEROO_LOCATION_LIST = 'apppair/deliveroo/location/portal/list',
  APPPAIR_DELIVEROO_DISCONNECT = 'apppair/deliveroo/disconnect/business',
  APPPAIR_DELIVEROO_STORE_CONNECT = 'apppair/deliveroo/pair/store',
  APPPAIR_DELIVEROO_STORE_DISCONNECT = 'apppair/deliveroo/disconnect/store',
  APPPAIR_DELIVEROO_AUTO_ACCEPT = 'apppair/deliveroo/auto-accept',

  // UberEats
  APPPAIR_UBEREATS_GET_LINK = 'apppair/ubereat/auth/get-link',
  APPPAIR_UBEREATS_PAIR_BUSINESS = 'apppair/ubereat/pair/business',
  APPPAIR_UBEREATS_LOCATION_LIST = 'apppair/ubereat/location/portal/list',
  APPPAIR_UBEREATS_DISCONNECT = 'apppair/ubereat/disconnect/business',
  APPPAIR_UBEREATS_STORE_CONNECT = 'apppair/ubereat/pair/store',
  APPPAIR_UBEREATS_STORE_DISCONNECT = 'apppair/ubereat/disconnect/store',
  APPPAIR_UBEREATS_AUTO_ACCEPT = 'apppair/ubereat/auto-accept',
  // VeriFactu
  APPPAIR_VERIFACTU_PAIR_BUSINESS = 'apppair/verifactu/pair/business',
  APPPAIR_VERIFACTU_LOCATION_LIST = 'apppair/verifactu/location/portal/list',
  APPPAIR_VERIFACTU_DISCONNECT = 'apppair/verifactu/disconnect/business',
  APPPAIR_VERIFACTU_STORE_CONNECT = 'apppair/verifactu/pair/store',
  APPPAIR_VERIFACTU_STORE_DISCONNECT = 'apppair/verifactu/disconnect/store',
  // Embargo
  APPPAIR_EMBARGO_STORE_DISCONNECT = 'apppair/embargo/disconnect/store',
  // Dotypos
  APPPAIR_DOTYPOS_PAIR_BUSINESS = 'apppair/dotypos/pair/business',
  APPPAIR_DOTYPOS_PAIR_STORE = 'apppair/dotypos/pair/store',
  APPPAIR_DOTYPOS_LOCATION_LIST = 'apppair/dotypos/location/portal/list',
  APPPAIR_DOTYPOS_DISCONNECT = 'apppair/dotypos/disconnect/business',
  APPPAIR_DOTYPOS_STORE_DISCONNECT = 'apppair/dotypos/disconnect/store',
  APPPAIR_DOTYPOS_CATALOGUE = 'apppair/dotypos/catalogue/pull',
  APPPAIR_DOTYPOS_PARTNER_STORES = 'apppair/dotypos/partner/store/list',
  // WorldPay
  APPPAIR_WORLDPAY_PAIR_BUSINESS = 'apppair/worldpay/pair/business',
  APPPAIR_WORLDPAY_DISCONNECT = 'apppair/worldpay/disconnect/business',
  APPPAIR_WORLDPAY_PAIR_TERMINAL = 'apppair/worldpay/pair/terminal',
  APPPAIR_WORLDPAY_TERMINAL_LIST = 'apppair/worldpay/terminal/portal/list',
  APPPAIR_WORLDPAY_TERMINAL_DISCONNECT = 'apppair/worldpay/disconnect/terminal',
  APPPAIR_WORLDPAY_TERMINAL_STATUS = 'apppair/worldpay/status/terminal',
  APPPAIR_WORLDPAY_TERMINAL_TEST_PAYMENT = 'apppair/worldpay/test-payment',
  // Xero
  APPPAIR_XERO_PAIR_BUSINESS = 'apppair/xero/pair/business',
  APPPAIR_XERO_DISCONNECT = 'apppair/xero/disconnect',
  APPPAIR_XERO_PAIR_STORE = 'apppair/xero/pair/store',
  APPPAIR_XERO_LOCATION_LIST = 'apppair/xero/location/portal/list',
  APPPAIR_XERO_STORE_DISCONNECT = 'apppair/xero/disconnect/store',
  APPPAIR_XERO_TRACKING_CATEGORIES = 'apppair/xero/tracking-categories/get',
  APPPAIR_XERO_CODE_LIST = 'apppair/xero/code/list',
  APPPAIR_XERO_CODE_SOURCES = 'apppair/xero/code/sources',
  APPPAIR_XERO_CODE_SAVE = 'apppair/xero/code/save',
  APPPAIR_XERO_ACCOUNT_LIST = 'apppair/xero/account/list',
  APPPAIR_XERO_TAX_RATE_LIST = 'apppair/xero/tax-rate/list',
  APPPAIR_XERO_PAYOUT_SYNC = 'apppair/xero/payout/sync',
  // Fourth
  APPPAIR_FOURTH_PAIR_BUSINESS = 'apppair/fourth/pair/business',
  APPPAIR_FOURTH_DISCONNECT = 'apppair/fourth/disconnect/business',
  APPPAIR_FOURTH_PAIR_STORE = 'apppair/fourth/pair/store',
  APPPAIR_FOURTH_LOCATION_LIST = 'apppair/fourth/location/portal/list',
  APPPAIR_FOURTH_STORE_DISCONNECT = 'apppair/fourth/disconnect/store',
  APPPAIR_FOURTH_MAPPING_LIST = 'apppair/fourth/mapping/list',
  APPPAIR_FOURTH_MAPPING_CONNECT = 'apppair/fourth/mapping/connect',
  APPPAIR_FOURTH_MAPPING_DISCONNECT = 'apppair/fourth/mapping/disconnect',
  APPPAIR_FOURTH_IMPORT_ITEMS = 'apppair/fourth/recipes/pull',
  APPPAIR_FOURTH_ITEMS_LIST = 'apppair/fourth/mapping/get-fourth-items',
  // Square Payment
  APPPAIR_SQUARE_PAYMENT_PAIR_BUSINESS = 'apppair/square/payment/pair/business',
  APPPAIR_SQUARE_PAYMENT_DISCONNECT = 'apppair/square/payment/disconnect/business',
  APPPAIR_SQUARE_PAYMENT_PAIR_TERMINAL = 'apppair/square/payment/pair/terminal',
  APPPAIR_SQUARE_PAYMENT_TERMINAL_LIST = 'apppair/square/payment/terminal/portal/list',
  APPPAIR_SQUARE_PAYMENT_TERMINAL_DISCONNECT = 'apppair/square/payment/disconnect/terminal',
  APPPAIR_SQUAER_PAYMENT_GENERATE_DEVICE_CODE = 'apppair/square/payment/terminal/get-device-code',
  // Adyen
  APPPAIR_ADYEN_PAIR_BUSINESS = 'apppair/adyen/pair/business',
  APPPAIR_ADYEN_DISCONNECT = 'apppair/adyen/disconnect/business',
  APPPAIR_ADYEN_STORE_LIST = 'apppair/adyen/store/list',
  APPPAIR_ADYEN_STORE_CREATE = 'apppair/adyen/store/create',
  APPPAIR_ADYEN_PAIR_TERMINAL = 'apppair/adyen/pair/terminal',
  APPPAIR_ADYEN_TERMINAL_LIST = 'apppair/adyen/terminal/portal/list',
  APPPAIR_ADYEN_TERMINAL_DISCONNECT = 'apppair/adyen/disconnect/terminal',
  APPPAIR_ADYEN_TERMINAL_TEST_PAYMENT = 'apppair/adyen/test-payment',
  APPPAIR_ADYEN_TERMINAL_TEST_REFUND = 'apppair/adyen/test-refund',
  // JustEat
  APPPAIR_JUSTEAT_PAIR_BUSINESS = 'apppair/justeat/pair/business',
  APPPAIR_JUSTEAT_PAIR_STORE = 'apppair/justeat/pair/store',
  APPPAIR_JUSTEAT_LOCATION_LIST = 'apppair/justeat/location/portal/list',
  APPPAIR_JUSTEAT_DISCONNECT = 'apppair/justeat/disconnect/business',
  APPPAIR_JUSTEAT_STORE_DISCONNECT = 'apppair/justeat/disconnect/store',
  APPPAIR_JUSTEAT_CATALOGUE = 'apppair/justeat/catalogue/pull',
  // Wealthon
  APPPAIR_WEALTHON_PAIR_BUSINESS = 'apppair/wealthon/pair/business',
  APPPAIR_WEALTHON_PAIR_STORE = 'apppair/wealthon/pair/store',
  APPPAIR_WEALTHON_LOCATION_LIST = 'apppair/wealthon/location/portal/list',
  APPPAIR_WEALTHON_DISCONNECT = 'apppair/wealthon/disconnect/business',
  APPPAIR_WEALTHON_STORE_DISCONNECT = 'apppair/wealthon/disconnect/store',

  APPPAIR_CHANNEL_STATUS = 'apppair/channel-store-status',
  KIOSK_LIST = 'kiosk/settings/list',
  KIOSK_SETTING_UPSERT = 'kiosk/settings/upsert',
  STORE_LAST_UPDATE = 'store/last-update',
  KIOSK_UPSERT = 'kiosk/settings/upsert',
  KIOSK_ARCHIVE = 'kiosk/settings/archive',
  CHANNEL_AVAILABILITY_PRIMARY = 'availability/channel/primary-data',
  CHANNEL_AVAILABILITY_SUPPLEMENTARY = 'availability/channel/supplementary-data',
  ENTITY_AVAILABILITY_LIST = '/availability/entity/portal/list',
  ENTITY_AVAILABILITY_UPDATE = '/availability/entity/portal/set',
  // Menu
  MENU_MAIN_LIST = 'menu/portal/list',
  MENU_BULK_UPDATE = 'menu/bulk/update',
  MENU_UPSERT = 'menu/upsert',
  MENU_ARCHIVE = 'menu/archive',
  MENU_DUPLICATE = 'menu/duplicate',
  // REVIEW: @Yazdan fix the typo in the name and update its references accordingly
  MENU_CATEGORY_LSIT = 'menu/category/portal/list',
  MENU_CATEGORY_UPSERT = 'menu/category/upsert',
  MENU_CATEGORY_ARCHIVE = 'menu/category/archive',
  MENU_CATEGORY_UPDATE_ORD = 'menu/category/update-ord',
  MENU_ITEM_LIST = 'menu/item/portal/list',
  MENU_ITEM_BULK_ADD = 'menu/item/portal/bulk/add',
  MENU_ITEM_MOVE = 'menu/item/portal/move',
  MENU_ITEM_REMOVE = 'menu/item/portal/remove',
  MENU_ITEM_UPDATE_ORD = 'menu/item/update-ord',
  MENU_ITEM_UPDATE = 'menu/item/portal/update',
  MENU_PUBLISH = 'menu/publish',
  MENU_PUBLISH_PAIRED_PARTNERS = 'menu/publish/portal/page-setup',
  MENU_ITEM_CATALOGUE = '/menu/item/catalogue',
  MENU_ITEM_BULK_UPDATE = 'menu/item/portal/bulk-update',
  MENU_HEALTH_CHECK = 'menu/health-check/pos',

  POS_PROFILES_LIST = 'profile/pos/list',
  POS_PROFILES_UPSERT = 'profile/pos/upsert',
  POS_PROFILES_ARCHIVE = 'profile/pos/archive',
  KDS_PROFILES_LIST = 'profile/kds/list',
  KDS_PROFILES_UPSERT = 'profile/kds/upsert',
  KDS_PROFILES_ARCHIVE = 'profile/kds/archive',
  PRINT_PROFILES_LIST = 'profile/print/list',
  TABLE_MANAGER_TABLE_MAP_LIST = 'table-manager/table-map/list',
  TABLE_MANAGER_RESERVATION_LIST = 'table-manager/reservation/list',
  TABLE_MANAGER_RESERVATION_UPSERT = 'table-manager/reservation/upsert',
  TABLE_MANAGER_RESERVATION_PROFILE_LIST = 'table-manager/reservation-profile/list',
  TABLE_MANAGER_RESERVATION_PROFILE_GET = 'table-manager/reservation-profile/get',
  TABLE_MANAGER_RESERVATION_PROFILE_UPSERT = 'table-manager/reservation-profile/upsert',
  TABLE_MANAGER_RESERVATION_PROFILE_ARCHIVE = 'table-manager/reservation-profile/archive',
  TABLE_MANAGER_TABLE_MAP_UPSERT = 'table-manager/table-map/upsert',
  TABLE_MANAGER_TABLE_MAP_ARCHIVE = 'table-manager/table-map/archive',
  TABLE_MANAGER_OBJECTS_UPSERT = 'table-manager/objects/upsert',
  TABLE_MANAGER_OBJECTS_LIST = 'table-manager/objects/list',
  TABLE_MANAGER_OBJECTS_ARCHIVE = 'table-manager/objects/archive',
  PRINT_PROFILES_UPSERT = 'profile/print/upsert',
  PRINT_PROFILES_ARCHIVE = 'profile/print/archive',
  DEVICE_LICENSES_LIST = 'settings/licenses/list',
  DEVICE_LICENSES_UPSERT = 'settings/licenses/upsert',
  DEVICE_LICENSES_ARCHIVE = 'settings/licenses/archive',
  DEVICE_LICENSES_MODIFY_CODE = 'settings/licenses/modify-code',
  DIGITAL_MENU_PROFILE_LIST = 'digital-menu/profile/list',
  DIGITAL_MENU_PROFILE_UPSERT = 'digital-menu/profile/upsert',
  DIGITAL_MENU_PROFILE_ARCHIVE = 'digital-menu/profile/archive',
  ORDER_STATUS_PROFILE_LIST = 'profile/order-status/list',
  ORDER_STATUS_PROFILE_UPSERT = 'profile/order-status/upsert',
  ORDER_STATUS_PROFILE_ARCHIVE = 'profile/order-status/archive',
  PRINTERS_LIST = 'settings/printers/list',
  PRINTERS_UPSERT = 'settings/printers/upsert',
  PRINTERS_ARCHIVE = 'settings/printers/archive',
  PRINTERS_MODELS = 'settings/printers/models',
  REPORT_TRANSACTIONS = 'report/transactions/list',
  REPORT_PAYMENTS_RECONCILIATION = 'report/payments/reconciliation/list',
  REPORT_ITEM_TRANSACTIONS = 'report/transactions/item-based/list',
  REPORT_SALES_BY_STORE = 'report/sales/by-store',
  REPORT_SALES_BY_BRANCH = 'report/sales/by-branch',
  REPORT_SALES_BY_CATEGORIES = 'report/sales/by-categories',
  REPORT_SALES_BY_CONDITION = 'report/sales/by-type',
  REPORT_SALES_BY_MODIFIERS = 'report/sales/by-modifiers',
  REPORT_STOCK_LEVELS = 'report/stock/low-stock-alerts',
  REPORT_ACCOUNT_CASHFLOW = 'report/account/cashflow',
  REPORT_ACCOUNT_PROFIT_AND_LOSS = 'report/account/profit-and-loss',
  REPORT_ITEM_MARGIN = 'report/stock/item-margin',
  REPORT_BALANCE_SHEET = 'report/account/balancesheet',
  REPORT_STAFF_ATTENDANCE = 'report/staff/attendance/daily-report',
  REPORT_STAFF_CLOCKED_HOURS = 'report/staff/attendance/clocked-hours',
  REPORT_SALES_COMPARE = 'report/sales/compare',
  REPORT_SALES_BY_PAYMENT = 'report/sales/by-channel-payment',
  REPORT_DAILY_SALES = 'report/sales/daily',
  REPORT_MONTHLY_SALES = 'report/sales/monthly',
  REPORT_APPLIED_PROMOTIONS = 'report/sales/promotion',
  REPORT_TAX = 'report/sales/tax',
  REPORT_TIP = 'report/sales/tip',
  REPORT_SALES_REFUND = 'report/sales/refunds',
  REPORT_HOURLY_SALES = 'report/sales/hourly',
  REPORT_ITEM_HOURLY_SALES = 'report/sales/by-items/hourly',
  REPORT_SALES_BY_ITEM = 'report/sales/by-items',
  REPORT_KDS_EFFICIENCY = 'report/kds/efficiency',
  REPORT_OVERVIEW_BENCHMARK = 'report/sales/overview/benchmark',
  REPORT_OVERVIEW_BY_CHANNEL = 'report/sales/overview/by-channels',
  REPORT_OVERVIEW_BY_TYPE = 'report/sales/overview/by-sales-type',
  REPORT_WEEKLY_SALES = 'report/sales/weekly',
  REPORT_OVERVIEW_BY_BRANCH = 'report/sales/overview/by-store',
  SALES_TYPES = 'sales-types/portal/list',
  SALES_TYPE_UPSERT = 'sales-types/upsert',
  SALES_TYPE_ARCHIVE = 'sales-types/archive',
  // Inventory
  ITEMS_MOVE = 'inventory/item/portal/move',
  INVENTORY_MODIFIER_PORTAL_LIST = 'inventory/modifier/portal/list',
  INVENTORY_MODIFIER_UPSERT = 'inventory/modifier/upsert',
  INVENTORY_MODIFIER_ARCHIVE = 'inventory/modifier/archive',
  INVENTORY_MODIFIER_CATEGORY_PORTAL_LIST = 'inventory/modifier/category/portal/list',
  INVENTORY_MODIFIER_BULK_UPDATE = 'inventory/modifier/bulk/update',
  INVENTORY_MODIFIER_UPDATE_ORD = 'inventory/modifier/update-ord',
  INVENTORY_CATEGORY_LIST = 'inventory/category/portal/list',
  INVENTORY_CATEGORY_UPSERT = 'inventory/category/upsert',
  INVENTORY_CATEGORY_ARCHIVE = 'inventory/category/archive',
  INVENTORY_CATEGORY_UPDATE_ORD = 'inventory/category/update-ord',
  INVENTORY_ITEM_IMPORT_CSV = 'inventory/item/import-csv',
  INVENTORY_ITEM_LIST = 'inventory/item/portal/list',
  INVENTORY_ITEM_UPSERT = 'inventory/item/upsert',
  INVENTORY_ITEM_ARCHIVE = 'inventory/item/archive',
  INVENTORY_ITEM_UPDATE_ORD = 'inventory/item/update-ord',
  INVENTORY_ITEM_VIEW = 'inventory/item/portal/view',
  INVENTORY_DISCOUNT_LIST = 'discount/portal/list',
  INVENTORY_DISCOUNT_VIEW = 'discount/portal/view',
  INVENTORY_DISCOUNT_UPSERT = 'discount/upsert',
  INVENTORY_DISCOUNT_ARCHIVE = 'discount/archive',
  INVENTORY_TRANSLATION_ITEM_LIST = 'inventory/translation/portal/item-list',
  INVENTORY_TRANSLATION_UPSERT = 'inventory/translation/upsert',
  INVENTORY_TRANSLATION_BULK_UPSERT = 'inventory/translation/bulk-upsert',
  INVENTORY_SELECT_ITEM_LIST = 'inventory/item/select-item-list',
  // Availability
  AVAILABILITY_LIST = 'availabilities/portal/list',
  AVAILABILITY_UPSERT = 'availabilities/upsert',
  AVAILABILITY_ARCHIVE = 'availabilities/archive',
  // Units
  UNIT_LIST = 'units/portal/list',
  UNIT_UPSERT = 'units/upsert',
  UNIT_ARCHIVE = 'units/archive',
  // Item Tags
  ITEM_TAG_LIST = 'tags/portal/list',
  ITEM_TAG_UPSERT = 'tags/upsert',
  ITEM_TAG_ARCHIVE = 'tags/archive',
  // Item Conditions
  ITEM_CONDITION_LIST = 'item-type/portal/list',
  ITEM_CONDITION_UPSERT = 'item-type/upsert',
  ITEM_CONDITION_ARCHIVE = 'item-type/archive',
  // Inventory Locations
  INVENTORY_LOCATION_LIST = 'inventory/location/portal/list',
  INVENTORY_LOCATION_UPSERT = 'inventory/location/upsert',
  INVENTORY_LOCATION_ARCHIVE = 'inventory/location/archive',
  // Sales Tax
  SALES_TAX_LIST = 'sales-tax/portal/list',
  SALES_TAX_UPSERT = 'sales-tax/upsert',
  SALES_TAX_ARCHIVE = 'sales-tax/archive',

  // Settings
  SETTINGS_LICENCES_CONNECT = 'settings/licenses/connect',
  SETTINGS_TEMPLATES_PORTAL_LIST = 'settings/templates/portal/list',
  SETTINGS_TEMPLATES_FIELDS = 'settings/templates/fields',
  SETTINGS_TEMPLATES_UPSERT = 'settings/templates/upsert',
  SETTINGS_TEMPLATES_ARCHIVE = 'settings/templates/archive',
  SETTINGS_CUSTOMER_GROUPS_LIST = 'settings/customer_group/portal/list',
  SETTINGS_CUSTOMER_GROUPS_UPSERT = 'settings/customer_group/upsert',
  SETTINGS_CUSTOMER_GROUPS_ARCHIVE = 'settings/customer_group/archive',
  SETTINGS_CUSTOM_REASONS_LIST = 'settings/reasons/portal/list',
  SETTINGS_CUSTOM_REASONS_UPSERT = 'settings/reasons/upsert',
  SETTINGS_CUSTOM_REASONS_ARCHIVE = 'settings/reasons/archive',
  SETTINGS_LANGUAGES_LIST = 'settings/languages/list',
  SETTINGS_LANGUAGES_UPSERT = 'settings/languages/upsert',
  SETTINGS_LANGUAGES_ARCHIVE = 'settings/languages/archive',
  SETTINGS_PAYMENT_METHOD_LIST = 'settings/payment-types/portal/list',
  SETTINGS_PAYMENT_METHOD_UPSERT = 'settings/payment-types/upsert',
  SETTINGS_PAYMENT_METHOD_ARCHIVE = 'settings/payment-types/archive',
  SETTINGS_SALE_FEES_UPSERT = 'settings/sale-fees/upsert',
  SETTINGS_SALE_FEES_list = 'settings/sale-fees/list',
  SETTINGS_SALE_FEES_ARCHIVE = 'settings/sale-fees/archive',
  SETTINGS_LOYALTY_RULE_GET = 'settings/loyalty/rule/get',
  SETTINGS_LOYALTY_RULE_SET = 'settings/loyalty/rule/set',
  SETTINGS_ARCHIVES_LIST = 'settings/restore/portal/list',
  SETTINGS_ARCHIVES_RESTORE = 'settings/restore/portal/restore',

  // Google
  GOOGLE_FONT_API_LIST = 'google/font-api-list',

  // Resources
  RESOURCES_DATA = 'resources/data',
  // AI
  AI_TRANSLATE_SINGLE = 'ai/translate/single',
  AI_TRANSLATE_OBJECT = 'ai/translate/bulk',
  // Gift Card
  GIFT_CARD_LIST = 'giftcard/scheme/list',
  GIFT_CARD_UPSERT = 'giftcard/scheme/upsert',
  GIFT_CARD_ARCHIVE = 'giftcard/scheme/archive',
  ISSUED_GIFT_CARD_LIST = 'giftcard/card/list',
  ISSUED_GIFT_CARD_VIEW = 'giftcard/card/portal/view',
  ISSUED_GIFT_CARD_UPSERT = 'giftcard/card/issue',
  ISSUED_GIFT_CARD_SEND = 'giftcard/card/send',
  ISSUED_GIFT_CARD_TOP_UP = 'giftcard/card/topup',
  // Tickets
  TICKET_LIST = 'ticket/list',
  TICKET_UPSERT = 'ticket/upsert',
  TICKET_MESSAGE_LIST = 'ticket/message/list',
  TICKET_MESSAGE_UPSERT = 'ticket/message/upsert',
  // Digital Ocean Attachments
  DIGITAL_OCEAN_PRESIGNED_URL_GENERATE = 'digital-ocean/presigned-url/generate',
  DIGITAL_OCEAN_LIST = 'digital-ocean/list',
  DIGITAL_OCEAN_DELETE = 'digital-ocean/delete',
  // Suppliers
  SUPPLIER_LIST = 'supplier/entity/portal/list',
  SUPPLIER_VIEW = 'supplier/entity/portal/view',
  SUPPLIER_UPSERT = 'supplier/entity/upsert',
  SUPPLIER_ARCHIVE = 'supplier/entity/archive',
  // Stock Take
  STOCK_TAKE_ITEMS = 'inventory/stocktake/items',
  STOCK_TAKE_UPSERT = 'inventory/stocktake/upsert',
  STOCK_TAKE_LIST = 'inventory/stocktake/list',
  STOCK_TAKE_DETAILS = 'inventory/stocktake/details',

  // Order Purchase
  PURCHASE_PORTAL_LIST = 'purchase/portal/list',
  PURCHASE_UPSERT = 'purchase/upsert',
  PURCHASE_APPROVE = 'purchase/approve',
  PURCHASE_PAYMENT_REGISTER = 'purchase/payment/register',
  PURCHASE_PAYMENT_DATA = 'purchase/payment/payment-data',
  PURCHASE_DELIVERY_DATA = 'purchase/delivery/delivery-data',
  PURCHASE_DELIVERY_REGISTER = 'purchase/delivery/register',
  PURCHASE_SEND_TO_SUPPLIER = 'purchase/send-to-supplier',

  // Accounting
  ACCOUNTING_JOURNAL_LIST = 'accounting/journals/portal/list',
  ACCOUNTING_JOURNAL_VIEW = 'accounting/journals/view',
  ACCOUNTING_JOURNAL_INSERT = 'accounting/journals/insert',
  ACCOUNTING_CHARTS_SUBSIDIARY_LEDGER_LIST = 'accounting/charts/portal/subsidiary-ledger-list',
  ACCOUNTING_CHARTS_SUBSIDIARY_LEDGER_UPSERT = 'accounting/charts/upsert/subsidiary-ledger',
  ACCOUNTING_CHARTS_SUB_LEDGER_LIST = 'accounting/charts/portal/sub-ledger-list',
  ACCOUNTING_CHARTS_SUB_LEDGER_ACCOUNT_LIST = 'accounting/charts/account-list',
  ACCOUNTING_CHARTS_SUB_LEDGER_UPSERT = 'accounting/charts/upsert/subledger',
  ACCOUNTING_TRANSACTIONS_LIST = 'accounting/transactions/portal/list',

  // Dashboard
  NEWS_LIST = 'news/list',
  MARKETING_MATERIAL_LIST = 'marketing-material/list',
  HELP_CENTER_CONTENT_LIST = '/help-centre/contents/list',
}
